import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { WinAnimatorExtended } from "./WinAnimatorExtended";

@engineComponent(ComponentTypes.DisplayObject)
export class WinAnimatorExtendedFS extends WinAnimatorExtended {}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/WinAnimatorExtendedFS.ts
 **/